import { formatPhoneNumber } from "../Components/dummyConstant/DummyConstant";

var moment = require("moment-timezone");

export const ConvertDate = (date) => {
  return moment(new Date(date)).format("YYYY-MM-DD").toString();
};
export const ValidateDate = (str) => {
  return str ? moment(str)?.utc()?.format("MM-DD-YYYY") === "Invalid date" ? "N/A" : moment(str)?.utc()?.format("MM-DD-YYYY") : "N/A";
};
export const ValidateISODate = (str) => {
  return str ? new Date(str).toISOString().slice(0, 10) : "MM-DD-YYYY";
};
export const ValidateDateUTC = (str) => {
  return str ? moment(str).utc().format('MM-DD-YYYY') : 'N/A'
}
export const ValidateDateAndTime = (str, type) => {
  if (type === "new")
    return str ? moment(new Date(str)).format("MM-DD-YYYY") : "N/A";
  else return str ? moment(str).format("MM-DD-YYYY hh:mm:ss") : "N/A";
};
export function formatSSN(value) {

  // clean the input for any non-digit values.
  const phoneNumber = value?.toString()?.replace(/[^\d]/g, "");
  if (phoneNumber?.length < 4) {
    return `${phoneNumber}`;
  }
  if (phoneNumber?.length == 4) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 4)}`;
  }
  if (phoneNumber?.length == 5) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 5)}-`;
  }
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 5)}-${phoneNumber.slice(5, 9)}`;
  // return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 5)}-${phoneNumber.slice(5, 9)}`;
}


export const ValidateText = (cond, str) => {
  return cond ? str : "N/A";
};

export const ValidateTextNull = (cond, str) => {
  return cond ? str : null;
};

export const showText = (data) => {
  if ([null, undefined, "", "null,null", " ", "undefined undefined"].includes(data)) return "N/A";
  return data;
};

export const showTextEmpty = (data) => {
  if ([null, undefined, "", "null,null", " ", "(undefined)", "(null)"].includes(data)) return "";
  return data;
};

export const CheckExpiry = (expire) => {
  const today = moment(new Date()).utc().format("MM-DD-YYYY").split("-");

  // If expiry year is greater
  if (expire[2] > today[2]) return true;

  // If expiry year is less
  if (expire[2] < today[2]) return false;

  // If expiry year is equal ( This is when the validation starts )
  if (expire[2] == today[2]) {
    // If the expiry month is greater than current month
    if (expire[0] - today[0] > 1) return true;

    if (expire[0] - today[0] == 1)
      if (expire[1] - today[1] + 30 <= 30) return false;
    // If month is less
    if (expire[0] < today[0]) return false;
    if (expire[0] == today[0]) {
      if (expire[1] < today[1]) return false;
      if (expire[1] - today[1] <= 30) return false;
    }
  }
};

export const changeDateFormat = (data) => {
  return moment(new Date(data)).utc().format("MM-DD-YYYY");
};


export const checkIfTrueOrFalse = (cond) => {
  if (cond === null) return "N/A"
  return cond === true ? "Yes" : "No"
}

export const getQuestion = (QuestionnaireData) => {

  if (QuestionnaireData) {
    return [
      // { head: "Applicant ID", value: QuestionnaireData?.ApplicantId },
      { head: "Are you able to perform essential functions of the job for which you are applying, with or without a reasonable accommodation?", value: checkIfTrueOrFalse(QuestionnaireData?.accommodation) },
      ...!QuestionnaireData?.accommodation ? [{ head: "if no please explain:", value: showText(QuestionnaireData?.accomodationComment) }] : [],
      { head: "When would you be available to begin work?", value: moment(QuestionnaireData?.availability).format("MM-DD-YYYY") },
      { head: "Are you bilingual?", value: checkIfTrueOrFalse(QuestionnaireData?.bilingual) },
      ...QuestionnaireData?.bilingual ? [{ head: "What Language? (Bilingual)", value: showText(QuestionnaireData?.bilingualLanguage) }] : [],
      { head: "Are you able to Pass an oral alcohol & drug test?", value: checkIfTrueOrFalse(QuestionnaireData?.drugTest) },
      { head: "Are you able to Pass a hair follicle test?", value: checkIfTrueOrFalse(QuestionnaireData?.hairTest) },
      { head: "Do you speak English?", value: checkIfTrueOrFalse(QuestionnaireData?.language) },
      { head: "Have you ever been convicted of a felony or a misdemeanor which resulted in imprisonment within the last seven years?", value: checkIfTrueOrFalse(QuestionnaireData?.prison) },
      { head: "If required, would you be willing to work relocate?", value: checkIfTrueOrFalse(QuestionnaireData?.relocate) },
      { head: "If required, would you be willing to work overtime?", value: checkIfTrueOrFalse(QuestionnaireData?.overTime) },
      { head: "If required, would you be willing to work holidays?", value: checkIfTrueOrFalse(QuestionnaireData?.holidays) },
      { head: "If required, would you be willing to work Shift?", value: showText(QuestionnaireData?.shift) },
      { head: "If required, would you be willing to work weekends?", value: checkIfTrueOrFalse(QuestionnaireData?.workWeekends) },
      { head: "If required, would you be willing to work travel?", value: checkIfTrueOrFalse(QuestionnaireData?.travels) },
      { head: "How did you hear about TGS?", value: showText(QuestionnaireData?.tgsComment) },
      { head: "If you were referred, who referred you?", value: showText(QuestionnaireData?.refer) },
      { head: "Have you worked for TGS before?", value: checkIfTrueOrFalse(QuestionnaireData?.workBefore) },
    ]
  }
  return null;

}
export const getDataSheet = (DataSheetData, DataSheetDataEmergency) => {
  return [
    // { head: "Applicant ID", value: DataSheetData?.id },
    // { head: "Applicant ID", value: ` ${showText (DataSheetData?.id) }/ ${DataSheetData?.firstName} ${DataSheetData?.middleName || ""} ${DataSheetData?.lastName}` },
    { head: "Email", value: showText(DataSheetData?.email) },
    { head: "SSN", value: formatSSN(showText(DataSheetData?.ssn)) || 'N/A' },
    { head: "Hire Date", value: (ValidateDate(DataSheetData?.hireDate)) },
    // { head: "Joining Date", value: moment(showText(DataSheetData?.joiningDate)).format("MM-DD-YYYY") },
    { head: "Home Phone", value: formatPhoneNumber(showText(DataSheetData?.homePhone)) || 'N/A' },
    { head: "Cell Phone", value: formatPhoneNumber(showText(DataSheetData?.cellPhone)) || 'N/A' },
    { head: "Date of birth", value: (ValidateDate(DataSheetData?.dateOfBirth)) },
    { head: "Birth Place", value: (showText(DataSheetData?.birthPlace)) ||'N/A' },

    { head: "Street Address", value: `${showText(DataSheetData?.address)}  ${showTextEmpty(DataSheetData?.address1)} ` },
    // ...DataSheetData?.address1 ? [{ head: "Street Address 2", value: showText(DataSheetData?.homePhone) }] : [],
    { head: "City / State", value: `${showText(DataSheetData?.city)} / ${DataSheetData?.state}` },
    { head: "Zip", value: showText(DataSheetData?.zip) },
    { head: "Marital Status", value: showText(DataSheetData?.maritalStatus) },
    // { head: "Job Id", value: showText(DataSheetData?.jobId) },
    // { head: "Job Category", value: showText(DataSheetData?.JobCategory?.name) },
    // { head: "Job Description", value: showText(DataSheetData?.JobDescription) },
    { head: "Position Level", value: showText(DataSheetData?.EmployeeLevel?.name) },
    { head: "Department", value: showText(DataSheetData?.SubDepartment?.Department?.name) },

    { head: "Sub Department", value: showText(DataSheetData?.SubDepartment?.name) },
    { head: "Supervisor", value: showText(DataSheetData?.SEmployee?.firstName) + " " + showTextEmpty(DataSheetData?.SEmployee?.lastName) },
    // { head: "US Citizen", value: showText(DataSheetData?.usCitizen) },
    // { head: "Notes For HR", value: showText(DataSheetData?.notesForHR) },
    // { head: "Offer Letter Notes", value: showText(DataSheetData?.offerLetterNotes) },
    { head: "Primary Emergency Contact Name", value: `${showText(DataSheetDataEmergency?.name)} ${showTextEmpty("(" + DataSheetDataEmergency?.relationship + ")")} ` },
    { head: "Primary Emergency Contact", value: `${showText(DataSheetDataEmergency?.city)} , ${showText(DataSheetDataEmergency?.state)} - ${showText(formatPhoneNumber(DataSheetDataEmergency?.phoneNumber))}` },
    { head: "  Backup Emergency Contact Name", value: `${showText(DataSheetDataEmergency?.BckName)} ${showTextEmpty("(" + DataSheetDataEmergency?.BckRelationship + ")")} ` },
    { head: "Backup Emergency Contact", value: `${showText(formatPhoneNumber(DataSheetDataEmergency?.BckPhone))}` },

  ]

}


export const validateLatLong = (text) => {
  let reg = /^[\d]*\.?[\d]*$/;
  return reg.test(text)
}
export const validateRulesBroken = (text) => {
  let reg = /^[0-9.,]+$/;
  if (text === "") return true
  return reg.test(text)
}

export const LabelIncident = ({ text }) => {

  return <><br /><h4 style={{ margin: "20px 0", width: "100%", borderBottom: "1px solid gray", color: "gray" }}>{text}</h4></>
}


export const checkDate = (res, type) => {
  if (type === "time") {
    return moment(res, "HH:mm").isValid() ? moment(res, "HH:mm") : undefined
  }
  if (type === "date") {
    return moment(res).isValid() ? moment(res).utc() : undefined
  }
}

export const checkRes = (res) => {
  return [undefined, "", null, "Invalid date"].includes(res) ? undefined : res
}

export const ErrorMessages = {
  requiredField: "Field cant be empty!"
}



export const checkStatus = (data) => {
  if (data) {
    let { IS_OS, IS_Description } = data
    if (IS_Description)
     return IS_Description
    // if (IS_OS == 'In Service')
    //   return IS_OS
    // else if (IS_OS == 'Out of Service')
    //   return IS_Description ? IS_Description : "N-A"
  }
  return 'N-A'

}